<!-- components/HotkeyHelpModal.vue -->
<template>
  <b-modal v-model="show" title="Atajos de teclado" ok-only ok-title="Cerrar" size="md">
    <div
      v-for="hk in hotkeys"
      :key="hk.id"
      class="hotkey-row d-flex justify-content-between align-items-center py-50 px-50"
      :class="{ 'hotkey-row--highlight': hk.highlight }"
    >
      <span>{{ hk.label }}</span>
      <span class="flex-shrink-0">
        <b-badge v-if="hk.ctrl" variant="light-secondary" class="mr-25">Ctrl</b-badge>
        <b-badge v-if="hk.shift" variant="light-secondary" class="mr-25">Shift</b-badge>
        <b-badge v-if="hk.alt" variant="light-secondary" class="mr-25">Alt</b-badge>
        <b-badge variant="light-primary">{{ hk.key || hk.code.replace('Key', '') }}</b-badge>
      </span>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent, ref, onMounted, onUnmounted, getCurrentInstance } from '@vue/composition-api'
import { BModal, BBadge } from 'bootstrap-vue'

export default defineComponent({
  components: { BModal, BBadge },
  props: {
    hotkeys: { type: Array, default: () => [] }
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const show = ref(false)

    const toogle = () => { show.value = !show.value }

    onMounted(() => vm.$root.$on('hotkey:help', toogle))
    onUnmounted(() => vm.$root.$off('hotkey:help', toogle))

    return { show }
  }
})
</script>

<style scoped>
.hotkey-row {
  border-radius: 0.428rem;
  transition: background-color 0.15s ease;
}

.hotkey-row--highlight {
  position: relative;
  border: 1px solid rgba(234, 84, 85, 0.55); /* $danger #ea5455 */
  background-color: rgba(234, 84, 85, 0.07);
  margin: 0.35rem 0;
  padding-left: 0.85rem !important;
  box-shadow: 0 0 0 2px rgba(234, 84, 85, 0.12);
}

/* Acento lateral */
.hotkey-row--highlight::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  border-radius: 0.428rem 0 0 0.428rem;
  background-color: #ea5455; /* $danger */
}

.hotkey-row--highlight > span:first-child {
  font-weight: 600;
}
</style>
